import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'prefix'
})
export class PrefixPipe implements PipeTransform {
  transform(input: string, prefix: string, suffix: string): string {
    return (input === null || input === undefined || input.trim() === "") ? "" : prefix + input + suffix;
  }
}
